import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-running-lab',
  templateUrl: './running-lab.component.html',
  styleUrls: ['./running-lab.component.scss']
})
export class RunningLabComponent implements OnInit {

  constructor(private keycloak: KeycloakService) { }
  showHidden: boolean = false;

  ngOnInit(): void {
    if (this.keycloak.getUserRoles().includes('LAB')) {
      this.showHidden = true;
    }
    else {
      this.showHidden = false;
    }
  }
}